<template>
  <v-dialog v-model="dialog" width="90%">
    <block v-if="loading"></block>
    <v-card class="py-3 px-3">
      <v-card-title class="text-h5">
        {{ title }}
      </v-card-title>

      <v-card-actions>
        <v-row>
          <v-col cols="12" class="tabsNh" style="padding: 14px">
            <v-col style="display: flex; justify-content: space-between; min-height: 50px">
              <div></div>
              <div>
                <v-btn small class="btn-save" @click.prevent="saveItemsToBeBilled()">
                  <v-icon>mdi-content-save</v-icon>
                  Guardar
                </v-btn>
              </div>
              <div>
                <v-btn small class="btn-save" @click.prevent="validateBeforeBill()">
                  <v-icon>mdi-cash-register</v-icon>
                  Facturar cliente
                </v-btn>
              </div>
            </v-col>
          </v-col>
        </v-row>
      </v-card-actions>

      <div style="height: 500px; overflow-y: auto; overflow-x: hidden; margin-top: 20px; margin-bottom: 20px; padding: 0 20px;">
        <v-row style="margin-top: 2rem">
          <v-row class="d-flex justify-center mb-2">
            <v-col cols="10" md="10" style="text-align: center; padding: 0px 0px 0px 0px !important;">
              <v-alert class="btndisable" style="padding: 4px !important; margin-bottom: 0px !important">
                Ver servicios por defecto
              </v-alert>
            </v-col>
            <v-col cols="1" md="1" style="text-align: right; padding: 0px 0px 0px 0px !important">
              <v-alert class="btndisable2" style="padding: 4px !important; margin-bottom: 0px !important">
                <button @click="togglehide1 = !togglehide1" v-show="!togglehide1" style="padding: 0px 4px 0px 4px !important"> Minimizar </button>
                <button @click="togglehide1 = !togglehide1" v-show="togglehide1" style="padding: 0px 4px 0px 4px !important"> Ampliar </button>
              </v-alert>
            </v-col>
          </v-row>
          <v-col cols="12" v-if="!togglehide1">
            <DxDataGrid class="isScrolledByGeneralFilter dataGridService" :data-source="servicesDefault" :show-borders="true" :column-auto-width="true" style="width: fit-content;">
              <DxScrolling row-rendering-mode="virtual" />
              <DxPaging :page-size="20" />
              <DxColumn :width="120" data-field="CodeService" header-cell-template="headerCodeService" />
              <template #headerCodeService> <div>Código de<br />servicio</div> </template>
              <DxColumn :min-width="220" data-field="NameService" header-cell-template="headerNameService" />
              <template #headerNameService> <div>Nombre de<br />servicio</div> </template>
              <DxColumn :min-width="240" data-field="Name" header-cell-template="headerName" />
              <template #headerName> <div>Nombre a<br />facturar</div> </template>
              <DxColumn :width="90" data-field="Price" caption="Precio" />
              <DxColumn :width="80" cell-template="quantity-template" caption="Agregado" />
              <DxColumn :width="55" cell-template="show-template" caption="" />
              <template #show-template="{ data }">
                <a href="#" class="mx-1" @click.prevent.stop="addService(data.data)">
                  <v-icon>mdi-plus</v-icon>
                </a>
              </template>
              <template #quantity-template="{ data }">
                <p style="margin: 0;">{{ findServiceQuantity(data.data) }}</p>
              </template>
            </DxDataGrid>
          </v-col>
        </v-row>

        <v-row style="margin-top: 2rem">
          <v-row class="d-flex justify-center mb-2">
            <v-col cols="10" md="10" style="text-align: center; padding: 0px 0px 0px 0px !important;">
              <v-alert class="btndisable" style="padding: 4px !important; margin-bottom: 0px !important">
                Ver todos los servicios
              </v-alert>
            </v-col>
            <v-col cols="1" md="1" style="text-align: right; padding: 0px 0px 0px 0px !important">
              <v-alert class="btndisable2" style="padding: 4px !important; margin-bottom: 0px !important">
                <button @click="togglehide2 = !togglehide2" v-show="!togglehide2" style="padding: 0px 4px 0px 4px !important"> Minimizar </button>
                <button @click="togglehide2 = !togglehide2" v-show="togglehide2" style="padding: 0px 4px 0px 4px !important"> Ampliar </button>
              </v-alert>
            </v-col>
          </v-row>
          <v-col cols="12" v-if="!togglehide2">
            <GeneralFilter :filterEndpoint="$API.services.getAllServicesFiltered" :search="search" @emptyFilter="getServices" @filtered="servicesFilterHandler">
              <DxDataGrid class="isScrolledByGeneralFilter dataGridService" :data-source="servicesToBill" key-expr="CodeService" :allow-column-reordering="true" :row-alternation-enabled="true" :show-borders="true" :column-auto-width="true" style="width: fit-content;">
                <DxScrolling row-rendering-mode="virtual" />
                <DxPaging :page-size="20" />
                <DxColumn :width="120" data-field="CodeService" caption="ID" />
                <DxColumn :min-width="220" data-field="NameService" header-cell-template="headerNameService" />
                <template #headerNameService> <div>Nombre de<br />servicio</div> </template>
                <DxColumn :min-width="240" data-field="Name" header-cell-template="headerNameLab" />
                <template #headerNameLab> <div>Nombre a<br />facturar</div> </template>
                <DxColumn :width="90" data-field="Price" caption="Precio" />
                <DxColumn :width="80" cell-template="quantity-template" caption="Agregado" />
                <DxColumn :width="55" cell-template="show-template" caption="" />
                <template #show-template="{ data }">
                  <a href="#" class="mx-1" @click.prevent.stop="addService(data.data)">
                    <v-icon>mdi-plus</v-icon>
                  </a>
                </template>
                <template #quantity-template="{ data }">
                  <p style="margin: 0;">{{ findServiceQuantity(data.data) }}</p>
                </template>
              </DxDataGrid>
            </GeneralFilter>
          </v-col>
        </v-row>

        <v-row style="margin-top: 2rem">
          <v-row class="d-flex justify-center mb-2">
            <v-col cols="10" md="10" style="text-align: center; padding: 0px 0px 0px 0px !important;">
              <v-alert class="btndisable" style="padding: 4px !important; margin-bottom: 0px !important">
                Ver todos los productos
              </v-alert>
            </v-col>
            <v-col cols="1" md="1" style="text-align: right; padding: 0px 0px 0px 0px !important">
              <v-alert class="btndisable2" style="padding: 4px !important; margin-bottom: 0px !important">
                <button @click="togglehide3 = !togglehide3" v-show="!togglehide3" style="padding: 0px 4px 0px 4px !important"> Minimizar </button>
                <button @click="togglehide3 = !togglehide3" v-show="togglehide3" style="padding: 0px 4px 0px 4px !important"> Ampliar </button>
              </v-alert>
            </v-col>
          </v-row>
          <v-col cols="12" v-if="!togglehide3">
            <GeneralFilter :filterEndpoint="$API.products.getProductsToBillForInvoiceFiltered" :search="filterProducts" @emptyFilter="getProducts" @filtered="productsFilterHandler">
              <v-row style="padding: 1rem;">
                <v-col cols="12" md="4" sm="6">
                  <v-autocomplete
                    outlined
                    dense
                    attach
                    v-model="PriceListSelected"
                    @change="getPriceListSelected()"
                    :items="priceListData"
                    item-text="id"
                    item-value="id"
                    label="Lista de precios"
                    :readonly="!$store.getters['rolesUser/getCustomRole'](239)"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" sm="4">
                  <v-autocomplete v-model="selectedWarehouse" item-text="Warehouse" item-value="ID_Warehouse" :items="warehouses" @change="handleSelectWarehouse" label="Almacenes" ref="werehouseRef" dense outlined attach />
                </v-col>
                <v-col cols="12" md="5" sm="6">
                  <p style="color: #e3191e !important; font-size: 12px; margin: 12px 0" v-if="warehouses.length == 0">No existen almacenes de productos para pacientes.</p>
                </v-col>
              </v-row>
              <DxDataGrid class="isScrolledByGeneralFilter dataGridService" :data-source="productsToBill" key-expr="billingKey" :allow-column-reordering="true" :row-alternation-enabled="true" :show-borders="true" :column-auto-width="true" style="width: fit-content;">
                <DxScrolling row-rendering-mode="virtual" />
                <DxPaging :page-size="20" />
                <DxColumn :width="120" data-field="ID_Item" caption="ID" />
                <DxColumn :min-width="320" data-field="ProductDisplayName" cssClass="product-name-cell" header-cell-template="headerProductName" />
                <template #headerProductName> <div>Nombre del<br />producto</div> </template>
                <DxColumn :width="90" cell-template="available-template" caption="Disponible" />
                <DxColumn v-if="!PriceListSelected" :min-width="150" data-field="PriceListName" caption="Lista de precios" />
                <DxColumn :width="90" data-field="ID_ItemBatch" caption="Lote" />
                <DxColumn :width="90" data-field="ItemPrice" caption="Precio" />
                <DxColumn :width="80" cell-template="quantity-template" caption="Agregado" />
                <DxColumn :width="55" cell-template="show-template" caption="" />
                <template #available-template="{ data }">
                  <span>{{ formatQuantity(data.data.ItemCurrentQuantity) }}</span>
                </template>
                <template #show-template="{ data }">
                  <a href="#" class="mx-1" @click.prevent.stop="addProduct(data.data)">
                    <v-icon>mdi-plus</v-icon>
                  </a>
                </template>
                <template #quantity-template="{ data }">
                  <p style="margin: 0;">{{ findProductQuantity(data.data) }}</p>
                </template>
              </DxDataGrid>
            </GeneralFilter>
          </v-col>
        </v-row>

        <v-row style="margin-top: 2rem">
          <v-col cols="12">
            <h4 style="padding: 16px;">Servicios seleccionados</h4>
            <div style="overflow-x: scroll; padding: 0 12px;">
              <DxDataGrid class="isScrolledByGeneralFilter dataGridService" :data-source="servicesToAdd" key-expr="CodeService" :allow-column-reordering="true" :row-alternation-enabled="true" :show-borders="true" :column-auto-width="true" style="width: fit-content;">
                <DxEditing :allow-updating="true" :select-text-on-edit-start="true" start-edit-action="click" mode="cell" />
                <DxScrolling row-rendering-mode="virtual" />
                <DxPaging :page-size="5" />
                <DxColumn :width="120" data-field="CodeService" :allow-editing="false" caption="ID" />
                <DxColumn :min-width="220" data-field="NameService" :allow-editing="false" header-cell-template="headerNameService" />
                <template #headerNameService> <div>Nombre de<br />servicio</div> </template>
                <DxColumn :min-width="240" data-field="Name" :allow-editing="false" header-cell-template="headerNameLab" />
                <template #headerNameLab> <div>Nombre a<br />facturar</div> </template>
                <DxColumn :min-width="150" data-field="TypeService" :allow-editing="false" header-cell-template="headerTypeservice" />
                <template #headerTypeservice> <div>Tipo de<br />servicio</div> </template>
                <DxColumn data-field="quantity" caption="Cantidad">
                  <DxFormat typed="fixedPoint" :precision="0" />
                  <DxRequiredRule message="La cantidad del servicio a facturar es requerida" />
                  <DxPatternRule :pattern="itemQtyPattern" message="La cantidad del servicio facturado solo puede contener numeros enteros mayores a 0" />
                </DxColumn>
                <DxColumn :width="90" data-field="Price" :allow-editing="true" caption="Precio" />
                <DxColumn :width="90" cell-template="total-template" :allow-editing="false" caption="Total" />
                <DxColumn :width="55" cell-template="del-template" caption="" />
                <template #del-template="{ data }">
                  <a href="#" class="mx-1" @click.prevent.stop="deleteService(data.data)">
                    <v-icon color="error">mdi-delete</v-icon>
                  </a>
                </template>
                <template #total-template="{ data }">
                  <div>{{ totalXQuantity(data.data) }}</div>
                </template>
              </DxDataGrid>
            </div>
          </v-col>
        </v-row>

        <v-row style="margin-top: 2rem">
          <v-col cols="12">
            <h4 style="padding: 16px;">Productos seleccionados</h4>
            <div style="overflow-x: scroll; padding: 0 12px;">
              <DxDataGrid class="isScrolledByGeneralFilter dataGridService" :data-source="productsToAdd" key-expr="billingKey" :allow-column-reordering="true" :row-alternation-enabled="true" :show-borders="true" :column-auto-width="true" style="width: fit-content;">
                <DxEditing :allow-updating="true" :select-text-on-edit-start="true" start-edit-action="click" mode="cell" />
                <DxScrolling row-rendering-mode="virtual" />
                <DxPaging :page-size="5" />
                <DxColumn :width="120" data-field="ID_Item" :allow-editing="false" caption="ID" />
                <DxColumn :min-width="320" data-field="ProductDisplayName" cssClass="product-name-cell" header-cell-template="headerProductName" />
                <template #headerProductName> <div>Nombre del<br />producto</div> </template>
                <DxColumn :width="110" data-field="ID_ItemBatch" :allow-editing="false" caption="Lote" />
                <DxColumn data-field="quantity" caption="Cantidad">
                  <DxFormat typed="fixedPoint" :precision="0" />
                  <DxRequiredRule message="La cantidad del producto a facturar es requerida" />
                  <DxPatternRule :pattern="itemQtyPattern" message="La cantidad del producto facturado solo puede contener numeros enteros mayores a 0" />
                </DxColumn>
                <DxColumn :width="90" data-field="ItemPrice" :allow-editing="true" caption="Precio" />
                <DxColumn :width="90" cell-template="total-template" :allow-editing="false" caption="Total" />
                <DxColumn :width="55" cell-template="del-template" caption="" />
                <template #del-template="{ data }">
                  <a href="#" class="mx-1" @click.prevent.stop="deleteProduct(data.data)">
                    <v-icon color="error">mdi-delete</v-icon>
                  </a>
                </template>
                <template #total-template="{ data }">
                  <div>{{ totalXQuantity({ ...data.data, Price: data.data.ItemPrice }) }}</div>
                </template>
              </DxDataGrid>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>

    <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert" />
    <alert v-model="confirm.show" @action="billedPatientsOfCustomer" :message="confirm.message" :title="confirm.title" :type="confirm.type" alt-color="warning" />
  </v-dialog>
</template>

<script>
import GeneralFilter from "@/components/GeneralFilter.vue";
import Alerts from "@/components/Alerts.vue";
import Block from "@/components/Block";
import { numberWithCommas } from "@/helpers/money";
import { DxDataGrid, DxColumn, DxPaging, DxScrolling, DxEditing, DxFormat, DxPatternRule, DxRequiredRule } from "devextreme-vue/data-grid";

export default {
  name: "VeterinaryBillingPanel",
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  components: {
    Alerts,
    Block,
    GeneralFilter,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxScrolling,
    DxEditing,
    DxFormat,
    DxPatternRule,
    DxRequiredRule,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: "Facturar paciente · Ficha de paciente",
    },
  },
  data() {
    const branch = JSON.parse(localStorage.getItem("branch")) || {};
    const user = JSON.parse(localStorage.getItem("user")) || {};

    return {
      loading: false,
      alert: { type: null, show: false, header: "", body: "" },
      confirm: { show: false, message: "", title: "", type: "confirm" },
      currency: branch.Currency || "$",
      ID_Branch: branch.ID_Branch || null,
      warehouses: [],
      selectedWarehouse: null,
      filterProducts: { filter: "", business: user.businessid, branch: user.branch, warehouse: null, pricelist: null },
      search: { filter: "" },
      servicesDefault: [],
      servicesToBill: [],
      productsToBill: [],
      servicesToAdd: [],
      productsToAdd: [],
      filterServices: { filter: "" },
      PriceListSelected: null,
      defaultPriceList: null,
      priceListData: [],
      togglehide1: true,
      togglehide2: true,
      togglehide3: true,
      itemQtyPattern: /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/i,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadData();
        }
      },
    },
    customerId(value) {
      if (value && this.modelValue) {
        this.loadData();
      }
    },
  },
  methods: {
    async loadData() {
      if (!this.customerId) {
        return;
      }
      this.loading = true;
      try {
        this.warehouses = await this.$API.warehouse.getWarehousesFiltered({ isPatient: true });
        await this.getAllPriceList();
        const found = this.warehouses.find((wh) => wh.Active == true && wh.ID_Branch == this.ID_Branch);
        this.selectedWarehouse = found ? found.ID_Warehouse : (this.warehouses.length === 0 ? 0 : this.warehouses[0].ID_Warehouse);
        this.filterProducts.warehouse = this.selectedWarehouse;
        this.filterProducts.pricelist = this.PriceListSelected;
        await this.getServices();
        await this.getProducts();
        await this.getDefaultServices();
        await this.getItemsToBeBilled();
      } finally {
        this.loading = false;
      }
    },
    closeAlert() {
      this.alert.show = false;
    },
    acceptAlert() {
      this.alert.show = false;
      if (this.alert.options === "bill") {
        this.billedPatientsOfCustomer();
      }
    },
    showAlert(type, header, body, options = null) {
      this.alert = { type, show: true, header, body, options };
    },
    showConfirm(title, message) {
      this.confirm = { show: true, message, title, type: "confirm" };
    },
    totalXQuantity({ Price, quantity }) {
      return `${this.currency}${numberWithCommas(parseFloat(Price * quantity).toFixed(2))}`;
    },
    async handleSelectWarehouse() {
      this.loading = true;
      this.filterProducts.warehouse = this.selectedWarehouse;
      await this.getProducts();
      this.$refs.werehouseRef?.blur();
      this.loading = false;
    },
    async getPriceListSelected() {
      this.loading = true;
      try {
        this.filterProducts.pricelist = this.PriceListSelected;
        await this.getProducts();
      } finally {
        this.loading = false;
      }
    },
    async getAllPriceList() {
      try {
        const user = JSON.parse(localStorage.getItem("user")) || {};
        const branchStorage = JSON.parse(localStorage.getItem("branch")) || {};
        const branchPrincipalPriceList =
          branchStorage?.BranchPrincipalPriceList?.value ??
          branchStorage?.BranchPrincipalPriceList ??
          null;
        const userPriceList = user.userpricelist;
        let response = [];
        if (this.$store.getters["rolesUser/getCustomRole"]("admin")) {
          response = await this.$API.priceList.priceListNoData();
        } else {
          response = await this.$API.priceList.priceListNotAdmin();
        }

        this.priceListData = response || [];
        const foundBranchPriceList = this.priceListData.find(
          (pl) => pl.id === branchPrincipalPriceList
        );
        const foundActive = this.priceListData.find((pl) => pl.Active == true && pl.ID_Branch == user?.branch);
        const fallback = this.priceListData.find((pl) => pl.id === "Precios por defecto");

        if (userPriceList != null && userPriceList != "") {
          this.PriceListSelected = userPriceList;
          this.defaultPriceList = this.PriceListSelected;
        } else if (foundBranchPriceList) {
          this.PriceListSelected = foundBranchPriceList.id;
          this.defaultPriceList = this.PriceListSelected;
        } else if (foundActive) {
          this.PriceListSelected = foundActive.id;
          this.defaultPriceList = this.PriceListSelected;
        } else {
          this.PriceListSelected = fallback ? fallback.id : null;
          this.defaultPriceList = this.PriceListSelected;
        }
      } catch (error) {
        console.warn("getAllPriceList", error);
      }
    },
    addService(data) {
      const isRepetitive = this.servicesToAdd.find((service) => service.ID_Service === data.ID_Service);
      if (!isRepetitive) {
        this.servicesToAdd.push({ ...data, quantity: 1, UnitPrice: parseFloat(data.Price), unitPrice: `${this.currency}${numberWithCommas(parseFloat(data.Price).toFixed(4))}` });
      } else {
        const services = this.servicesToAdd.find((service) => service.ID_Service === data.ID_Service);
        if (services) services.quantity++;
      }
    },
    addProduct(data) {
      const isRepetitive = this.productsToAdd.find((item) => item.ID_Item === data.ID_Item && item.ID_ItemBatch === data.ID_ItemBatch && item.PriceListName === data.PriceListName);
      if (!isRepetitive) {
        this.productsToAdd.push({ ...data, ProductDisplayName: this.getProductDisplayName(data), billingKey: `${data.ID_Item}-${data.ID_ItemBatch || "NO_BATCH"}-${data.PriceListName || "NO_PRICE"}`, quantity: 1, UnitPrice: parseFloat(data.ItemPrice), unitPrice: `${this.currency}${numberWithCommas(parseFloat(data.ItemPrice).toFixed(4))}` });
      } else {
        const product = this.productsToAdd.find((item) => item.ID_Item === data.ID_Item && item.ID_ItemBatch === data.ID_ItemBatch && item.PriceListName === data.PriceListName);
        if (product) product.quantity++;
      }
    },
    deleteService(data) {
      const serviceIndex = this.servicesToAdd.findIndex((service) => service.CodeService === data.CodeService);
      if (serviceIndex !== -1) this.servicesToAdd.splice(serviceIndex, 1);
    },
    deleteProduct(data) {
      const index = this.productsToAdd.findIndex((item) => item.ID_Item === data.ID_Item && item.ID_ItemBatch === data.ID_ItemBatch && item.PriceListName === data.PriceListName);
      if (index !== -1) this.productsToAdd.splice(index, 1);
    },
    getServices() {
      return this.$API.services.getAllServices(this.filterServices).then((response) => {
        this.servicesToBill = response;
      });
    },
    getProducts() {
      return this.$API.products.getProductsToBillForInvoiceFiltered(this.filterProducts).then((response) => {
        this.productsToBill = (response || []).map((item) => ({
          ...item,
          ProductDisplayName: this.getProductDisplayName(item),
          billingKey: `${item.ID_Item}-${item.ID_ItemBatch || "NO_BATCH"}-${item.PriceListName || "NO_PRICE"}`,
        }));
      });
    },
    getDefaultServices() {
      return this.$API.services.getDefaultServices().then((response) => {
        this.servicesDefault = response;
      });
    },
    servicesFilterHandler(response) {
      this.servicesToBill = response;
    },
    productsFilterHandler(response) {
      this.productsToBill = (response || []).map((item) => ({
        ...item,
        ProductDisplayName: this.getProductDisplayName(item),
        billingKey: `${item.ID_Item}-${item.ID_ItemBatch || "NO_BATCH"}-${item.PriceListName || "NO_PRICE"}`,
      }));
    },
    normalizeName(value) {
      return (value || "").toString().trim().replace(/\s+/g, " ").toLowerCase();
    },
    formatQuantity(value) {
      const numberValue = Number(value);
      if (!Number.isFinite(numberValue)) {
        return value ?? "";
      }
      return new Intl.NumberFormat("es-ES", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(numberValue);
    },
    getProductDisplayName(item) {
      const itemName = (item?.ItemName || "").toString().trim();
      const commercialName = (item?.ItemComercialName || "").toString().trim();
      if (!itemName) {
        return commercialName;
      }
      if (!commercialName) {
        return itemName;
      }
      if (this.normalizeName(itemName) === this.normalizeName(commercialName)) {
        return itemName;
      }
      return `${itemName} - ${commercialName}`;
    },
    findServiceQuantity(data) {
      return this.servicesToAdd.find((item) => item.CodeService === data.CodeService)?.quantity || "";
    },
    findProductQuantity(data) {
      return this.productsToAdd.find((item) => item.ID_Item === data.ID_Item && item.ID_ItemBatch === data.ID_ItemBatch && item.PriceListName === data.PriceListName)?.quantity || "";
    },
    async getItemsToBeBilled() {
      if (!this.customerId) {
        return;
      }
      const [servicesResponse, productsResponse] = await Promise.all([
        this.$API.veterinarypatients.getServicesToBeBilled({ customer: this.customerId }),
        this.$API.veterinarypatients.getProductsToBeBilled({ customer: this.customerId }),
      ]);

      this.servicesToAdd = (servicesResponse || []).map((service) => ({
        ...service,
        unitPrice: `${this.currency}${numberWithCommas(parseFloat(service.Price).toFixed(4))}`,
      }));

      if (productsResponse?.success) {
        this.productsToAdd = (productsResponse.data || []).map((item) => ({
          ...item,
          ProductDisplayName: this.getProductDisplayName(item),
          billingKey: `${item.ID_Item}-${item.ID_ItemBatch || "NO_BATCH"}-${item.PriceListName || "NO_PRICE"}-${item.Pk_billing_patients_control_of_products || ""}`,
          quantity: item.Quantity,
          unitPrice: `${this.currency}${numberWithCommas(parseFloat(item.ItemPrice).toFixed(4))}`,
        }));
      }
    },
    async saveItemsToBeBilled() {
      this.loading = true;
      try {
        await this.$API.veterinarypatients.saveServicesToBeBilled({ customer: this.customerId, services: this.servicesToAdd });
        await this.$API.veterinarypatients.saveProductsToBeBilled({ customer: this.customerId, products: this.productsToAdd });
        await this.getItemsToBeBilled();
        this.showAlert("success", "Exito", "Los datos de facturación de este paciente han sido guardados.");
      } catch (error) {
        console.log(error);
        this.showAlert("warning", "Advertencia", "Ha ocurrido un error, por favor intentarlo nuevamente.");
      } finally {
        this.loading = false;
      }
    },
    async validateBeforeBill() {
      if (this.servicesToAdd.length || this.productsToAdd.length) {
        await this.billedPatientsOfCustomer();
      } else {
        this.showConfirm("Advertencia", "No hay servicios ni productos registrados, ¿está seguro de crear una factura vacía?");
      }
    },
    async billedPatientsOfCustomer() {
      this.confirm.show = false;
      this.loading = true;
      try {
        await this.$API.veterinarypatients.saveServicesToBeBilled({ customer: this.customerId, services: this.servicesToAdd });
        await this.$API.veterinarypatients.saveProductsToBeBilled({ customer: this.customerId, products: this.productsToAdd });
        const responseBill = await this.$API.veterinarypatients.billedPatientsOfCustomer({ customer: this.customerId });
        if (responseBill?.status === false) {
          this.showAlert("dangerHtml", "Advertencia", "No se puede crear el comprobante porque se encontraron los siguientes errores: <br/><br/>" + responseBill.message);
          return;
        }
        this.showAlert("success", "Exito", `Se ha realizado la factura de los ${this.servicesToAdd.length && this.productsToAdd.length ? "servicios y productos" : this.servicesToAdd.length ? "servicios" : this.productsToAdd.length ? "productos" : "items"} seleccionados, podrá observarla en el módulo de POS en listo para facturar.`);
        await this.getItemsToBeBilled();
        this.$emit("billed", responseBill);
      } catch (error) {
        console.log(error);
        this.showAlert("warning", "Advertencia", "Ha ocurrido un error, por favor intentarlo nuevamente.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.btndisable {
  background-color: #41464c !important;
  color: white;
}

.tabsNh {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.btndisable2 {
  background-color: #1976d2 !important;
  color: white;
}

.dataGridService {
  min-width: 500px !important;
}

.product-name-cell {
  white-space: normal !important;
  word-break: break-word;
  line-height: 1.25;
}
</style>
